import { useCreatePatientReportMutation } from '../api';

export const useCreateReportUseCase = () => {
  const [createReport, { isLoading, isSuccess, data, error }] = useCreatePatientReportMutation();

  return { createReport, data, isLoading, isSuccess, error };
};
